import { useTranslation } from "react-i18next";

import { Avatar, Header } from "@pentabd/ui";
import { IconFileShield02 } from "@pentabd/icons";

import { ROUTES } from "@constants/routes";

const {
  HRM: { DOSSIER },
} = ROUTES;

type DossierEmployeeDetailsHeaderPropType = {
  employeeName: string;
  employeeImage?: string;
  employeePosition: string;
};

export function DossierEmployeeDetailsHeader({
  employeeName,
  employeeImage,
  employeePosition,
}: DossierEmployeeDetailsHeaderPropType) {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconFileShield02 fill="dark" size="20" />,
    },
    {
      label: t("DOSSIER_LIST.BREADCRUMBS.FIRST_STEP"),
      link: DOSSIER,
    },
    {
      label: employeeName,
    },
  ];

  const headerText = {
    header: employeeName,
    subHeader: employeePosition,
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      avatar={<Avatar name={employeeName} imageURL={employeeImage} />}
    />
  );
}
